import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../../Contexts/ProfileContext';
import { isSocialLoginType } from '../../utils/authConstants';

/**
 * Redirects manual/OTP users with passwordSet === null to /auth/set-password.
 * Skips social OAuth accounts (google, facebook, twitter).
 */
export default function PasswordSetupGuard({ children }) {
  const location = useLocation();
  const { profileData, isProfileLoaded } = useProfile();

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const pathname = location?.pathname || '';

  const isAuthPage =
    pathname.startsWith('/auth/login') ||
    pathname.startsWith('/auth/verify') ||
    pathname.startsWith('/auth/set-password');

  if (!token || isAuthPage) {
    return children;
  }

  if (!isProfileLoaded) {
    return children;
  }

  const loginType = profileData?.data?.loginType;
  const isSocialAccount = isSocialLoginType(loginType);

  if (isSocialAccount) {
    return children;
  }

  const passwordSet = profileData?.data?.passwordSet;
  const passwordSetInStorage = typeof window !== 'undefined' && localStorage.getItem('passwordSet') === 'true';
  const skippedThisSession = typeof window !== 'undefined' && sessionStorage.getItem('passwordSetupSkipped');

  // Only redirect when passwordSet is null (not when false) and user hasn't skipped
  if (passwordSet == null && !passwordSetInStorage && !skippedThisSession) {
    return <Navigate to="/auth/set-password" replace state={{ from: pathname }} />;
  }

  return children;
}
